import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'East Bloomfield Historical Society' },
	{
		name: 'description',
		content: 'The Historical Society of the Town of East Bloomfield.',
	},
]

export default function Index() {
	return (
		<div className="pt-4 pb-8">
			<div className="mx-auto max-w-6xl sm:px-6 lg:px-8">
				<p className="p-4 text-lg">
					The East Bloomfield Historical Society received its charter from the
					New York State Board of Education in 1969. The &quot;Historical
					Society of the Town of East Bloomfield&quot; known as the &quot;East
					Bloomfield Historical Society&quot;, is the result of the
					determination and perseverance of one local resident, Mrs. Lena Saxby
					Steele. Mrs. Steele was a life-long resident of East Bloomfield and
					had an avid interest in the history of the area. Through her efforts,
					the Historical Society was formed with the mission of preserving and
					promoting an understanding of the community&apos;s history for present
					and future generations. Historical artifacts and documents are
					preserved and available to all interested residents and individuals.
				</p>
				<p className="p-4 text-lg">
					The Society resides in the three-story brick East Bloomfield Academy
					school building dating to 1838. Currently, over 7,000 artifacts are
					housed at the Academy building with more being added each month. In
					November of each year, the Society gathers as a whole for the annual
					dinner meeting. The annual meeting offers an opportunity for the
					membership to review the past year, set goals for the coming year, and
					elect Trustees to lead the Society. The Society welcomes volunteers
					and individuals interested in serving on the Board of Trustees.
					Together, we will continue to record and preserve daily events of life
					in Bloomfield for the education and enjoyment of both present and
					future generations.
				</p>
			</div>
		</div>
	)
}
